import { gql } from '@apollo/client'

export const CREATE_CAREER_ENTRY = gql`
  mutation CreateCareerEntry($input: CreateCareerEntryInput!) {
    createCareerEntry(input: $input) {
      careerEntry {
        id
        role
        startDate
        endDate
        details
        careerOrganization {
          id
          name
        }
      }
      errors
    }
  }
`

export const UPDATE_CAREER_ENTRY = gql`
  mutation UpdateCareerEntry($input: UpdateCareerEntryInput!) {
    updateCareerEntry(input: $input) {
      careerEntry {
        id
        role
        startDate
        endDate
        details
        careerOrganization {
          id
          name
        }
      }
      errors
    }
  }
`

export const UPDATE_CAREER_STATUS = gql`
  mutation UpdateCareerStatus($input: UpdateCareerStatusInput!) {
    updateCareerStatus(input: $input) {
      userAccount {
        id
        careerStatus
      }
      errors
    }
  }
`

export const DELETE_CAREER_ENTRY = gql`
  mutation DeleteCareerEntry($input: DeleteCareerEntryInput!) {
    deleteCareerEntry(input: $input) {
      success
      errors
    }
  }
`
